export default __webpack_public_path__ + "static/media/pic2.bb169b02.jpg";